import { observable } from "mobx";

export type AdminStatisticsCard = {
  value: number;
  icon: "person" | "receipt";
};

export type AdminStatisticsGraphData = {
  labels: string[];
  values: number[];
  total?: number;
};

export default class AdminStatistics {
  @observable
  statCards: Record<string, AdminStatisticsCard>;

  @observable
  lastLoginGraphData: AdminStatisticsGraphData;

  @observable
  registrationGraphData: AdminStatisticsGraphData;

  totalRegistrations: number;
}
